import {
  setUserSession,
  setVenueInfo,
  setOnboardingComplete,
  setEmployeeInfo,
  logoutUser,
} from '../slices/currentUserSlice';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../../firebase';

// Action to save user session after sign-in
export const saveUserSession =
  (user, authMethod = 'unknown') =>
  async (dispatch) => {
    if (user) {
      const { uid, email, displayName } = user;

      // Save user information in Redux
      const userInfo = { uid, email, displayName, authMethod };
      dispatch(setUserSession(userInfo));

      // Save user info in localStorage for persistence
      localStorage.setItem('userSession', JSON.stringify(userInfo));

      // Restore employee and venue info from localStorage if they exist
      const storedVenueInfo = localStorage.getItem('venueInfo');
      const storedEmployeeInfo = localStorage.getItem('employeeInfo');
      const cachedOnboarding = localStorage.getItem('isOnboardingComplete');
      if (storedVenueInfo) {
        dispatch(setVenueInfo(JSON.parse(storedVenueInfo)));
      }
      if (storedEmployeeInfo) {
        dispatch(setEmployeeInfo(JSON.parse(storedEmployeeInfo)));
      }
      if (cachedOnboarding === 'true') {
        dispatch(setOnboardingComplete());
      } else {
        // Query Firestore if not in cache
        const userDocRef = doc(db, 'users', uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists() && userDoc.data().isOnboardingComplete) {
          dispatch(setOnboardingComplete());
          localStorage.setItem('isOnboardingComplete', 'true'); // Cache value
        }
      }
    } else {
      // Logout management or session cleanup
      dispatch(setUserSession(null));
      dispatch(logoutUser());
      localStorage.removeItem('isOnboardingComplete');
      localStorage.removeItem('userSession');
      localStorage.removeItem('venueInfo');
      localStorage.removeItem('employeeInfo');
    }
  };

export const linkUnionAccount = (venueId, pin) => async (dispatch) => {
  try {
    const functions = getFunctions();
    const linkUnionAccountCallable = httpsCallable(functions, 'linkEmployeeFromUnionPinAndVenue');
    const result = await linkUnionAccountCallable({ vid: venueId, pin });

    if (result?.data) {
      const { venue, employee } = result.data;

      // Save venue and employee information in Redux
      dispatch(setVenueInfo(venue));
      dispatch(setEmployeeInfo(employee));
      // Save venue and employee info in localStorage for persistence
      localStorage.setItem('venueInfo', JSON.stringify(venue));
      localStorage.setItem('employeeInfo', JSON.stringify(employee));
    } else {
      console.error('Error: Invalid PIN or venue.');
    }
  } catch (error) {
    console.error('Error linking Union account:', error);
  }
};

//Action to logout user

export const logout = () => async (dispatch) => {
  try {
    await auth.signOut();
    dispatch(logoutUser());
    // Remove all session-related data from localStorage
    localStorage.removeItem('isOnboardingComplete');
    localStorage.removeItem('userSession');
    localStorage.removeItem('venueInfo');
    localStorage.removeItem('employeeInfo');
    // Clear global state
  } catch (error) {
    console.error('Error logging out:', error);
  }
};
